module.exports = __webpack_public_path__ + "static/media/Pinterest.3364545f.svg";